// Imports
import { initJetEngineRadioFix } from "./modules/accessibilityImprovement/JetEngine/jetEngineRadioFix.js";
import { initRearangeTimelineOrder } from './modules/accessibilityImprovement/JetEngine/rearangeTimelineOrder.js';
import { initJetEngineSliderAccessibility } from './modules/accessibilityImprovement/JetEngine/listingGridSlider.js';
import { initSmartFilterPaginationOptimization } from './modules/accessibilityImprovement/JetEngine/smartFilterPaginationOptimization.js';
import { initPopupCloseButtonOptimization } from './modules/accessibilityImprovement/JetEngine/popupCloseButtonOptimization.js';

document.addEventListener("DOMContentLoaded", function () {
    initJetEngineRadioFix();
    initRearangeTimelineOrder();
    initJetEngineSliderAccessibility();
    initSmartFilterPaginationOptimization();
    initPopupCloseButtonOptimization();
});